import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ContactType } from '@/resources/Contact';
import { ChakraTheme } from '@/styles/themes/default';
import { IThemeProps } from '@/styles/themes/types';

import { Container } from '../core/Grid';
import { H1 } from '../core/Heading';

const Wrapper = styled.header<IThemeProps>`
  margin-top: -104px;
  padding-top: 176px;
  padding-bottom: 56px;

  background: radial-gradient(
    98.44% 95.14% at -0.8% 0%,
    #f563ff 0%,
    rgba(8, 255, 255, 0.5) 10.76%,
    rgba(15, 255, 231, 0.35) 30%,
    rgba(255, 120, 147, 0.1) 55%,
    rgba(0, 5, 15, 0) 86%
  );
  background-color: ${({ theme }) => theme.legacy.colors.black};
`;

interface IHeaderProps {
  type: ContactType;
}

export const Header: FC<IHeaderProps> = ({ type }) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Container>
        <H1
          css={(theme: ChakraTheme) => css`
            color: ${theme.legacy.colors.white};
          `}
        >
          {t(type === ContactType.CONFERENCES ? 'contactForm.titleConferences' : 'contactForm.title')}
        </H1>
      </Container>
    </Wrapper>
  );
};
